import { RouteObject } from 'react-router-dom';
import DraftClaimLineItemLayout from '~/app/features/crew/claim-line-items/draft-layout/DraftClaimLineItemLayout';
import {
  loader as draftClaimLineItemLayoutLoader,
  shouldRevalidate as draftClaimLineItemLayoutShouldRevalidate,
} from '~/app/features/crew/claim-line-items/draft-layout/draftClaimLineItem';
import ClaimLineItemMetaPage from '~/app/features/crew/claim-line-items/meta/ClaimLineItemMetaPage';
import {
  action as claimLineItemMetaAction,
  loader as claimLineItemMetaLoader,
} from '~/app/features/crew/claim-line-items/meta/claimLineItemMeta';
import QuantityPage from '~/app/features/crew/claim-line-items/quantity/QuantityPage';
import {
  action as quantityAction,
  loader as quantityLoader,
} from '~/app/features/crew/claim-line-items/quantity/quantity';
import ReasonDetailPage from '~/app/features/crew/claim-line-items/reason-detail/ReasonDetailPage';
import {
  action as reasonDetailAction,
  loader as reasonDetailLoader,
} from '~/app/features/crew/claim-line-items/reason-detail/reasonDetail';
import ReasonFollowUpPage from '~/app/features/crew/claim-line-items/reason-follow-up/ReasonFollowUpPage';
import {
  action as reasonFollowUpAction,
  loader as reasonFollowUpLoader,
  shouldRevalidate as reasonFollowUpShouldRevalidate,
} from '~/app/features/crew/claim-line-items/reason-follow-up/reasonFollowUp';
import ClaimLineItemReasonPage from '~/app/features/crew/claim-line-items/reason/ClaimLineItemReasonPage';
import {
  action as claimLineItemReasonAction,
  loader as claimLineItemReasonLoader,
} from '~/app/features/crew/claim-line-items/reason/claimLineItemReason';
import ResolutionPage from '~/app/features/crew/claim-line-items/resolution/ResolutionPage';
import {
  action as resolutionAction,
  loader as resolutionLoader,
} from '~/app/features/crew/claim-line-items/resolution/resolution';
import ShippingProtectionPage from '~/app/features/crew/claim-line-items/shipping-protection/ShippingProtectionPage';
import { loader as shippingProtectionLoader } from '~/app/features/crew/claim-line-items/shipping-protection/shippingProtection';
import ClaimLineItemsSummaryPage from '~/app/features/crew/claim-line-items/summary/ClaimLineItemsSummaryPage';
import {
  action as claimLineItemsSummaryAction,
  loader as claimLineItemsSummaryLoader,
} from '~/app/features/crew/claim-line-items/summary/claimLineItemsSummary';
import ReturnMethodsPage from '~/app/features/crew/return-methods/ReturnMethodsPage';
import {
  action as returnMethodsAction,
  loader as returnMethodsLoader,
} from '~/app/features/crew/return-methods/returnMethods';
import WarrantyReviewPage from '~/app/features/crew/warranty-review/WarrantyReviewPage';
import {
  action as warrantyReviewAction,
  loader as warrantyReviewLoader,
} from '~/app/features/crew/warranty-review/warrantyReview';
import Address from './address';
import ReturnSummary from './return-summary';

export default {
  id: 'crewClaim',
  path: ':claimType',
  children: [
    {
      index: true,
      loader: claimLineItemsSummaryLoader,
      Component: ClaimLineItemsSummaryPage,
      action: claimLineItemsSummaryAction,
    },
    {
      id: 'draftClaimLineItemLayout',
      path: ':draftId',
      loader: draftClaimLineItemLayoutLoader,
      Component: DraftClaimLineItemLayout,
      shouldRevalidate: draftClaimLineItemLayoutShouldRevalidate,
      children: [
        {
          id: 'claimLineItemQuantity',
          index: true,
          Component: QuantityPage,
          action: quantityAction,
          loader: quantityLoader,
        },
        {
          id: 'claimLineItemReason',
          path: 'reason',
          Component: ClaimLineItemReasonPage,
          action: claimLineItemReasonAction,
          loader: claimLineItemReasonLoader,
        },
        {
          id: 'reasonDetail',
          // ? tempted to simplify this to just reason-detail, not sure if really useful considering the id is on state
          path: 'reason/:reasonId',
          Component: ReasonDetailPage,
          loader: reasonDetailLoader,
          action: reasonDetailAction,
        },
        {
          id: 'claimLineItemMeta',
          path: 'meta',
          Component: ClaimLineItemMetaPage,
          loader: claimLineItemMetaLoader,
          action: claimLineItemMetaAction,
        },
        {
          id: 'reasonFollowUp',
          path: 'follow-up',
          Component: ReasonFollowUpPage,
          loader: reasonFollowUpLoader,
          action: reasonFollowUpAction,
          shouldRevalidate: reasonFollowUpShouldRevalidate,
        },
        {
          id: 'shippingProtection',
          path: 'shipping-protection',
          Component: ShippingProtectionPage,
          loader: shippingProtectionLoader,
        },
        {
          id: 'resolution',
          path: 'resolution',
          Component: ResolutionPage,
          action: resolutionAction,
          loader: resolutionLoader,
        },
      ],
    },
    Address,
    {
      id: 'returnMethods',
      path: 'return-methods',
      action: returnMethodsAction,
      loader: returnMethodsLoader,
      Component: ReturnMethodsPage,
    },
    {
      id: 'reviewWarranty',
      path: 'warranty-review',
      Component: WarrantyReviewPage,
      loader: warrantyReviewLoader,
      action: warrantyReviewAction,
    },
    ReturnSummary,
  ],
} satisfies RouteObject;
